/**
 * ReadyRowActions — Aktionsleiste einer aufgeklappten `ReadyRow` (T8).
 * Ausgelagert, damit `ReadyRow.tsx` unter dem Component-Size-Limit bleibt
 * (Muster `SuggestionCardActions.tsx`).
 */
import { useTranslation } from 'react-i18next'

import { EID } from '@/lib/element-ids.registry'

export interface ReadyRowActionsProps {
  idSuffix: string
  busy: boolean
  onEdit: () => void
  onDiscard: () => void
  onApply: () => void
}

export function ReadyRowActions({ idSuffix, busy, onEdit, onDiscard, onApply }: ReadyRowActionsProps) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        id={`${EID['text-bulk-ready-row-edit-btn']}-${idSuffix}`}
        disabled={busy}
        onClick={onEdit}
        className="rounded-md border border-neutral-300 px-2.5 py-1.5 text-xs font-medium text-neutral-700 hover:bg-neutral-50 disabled:opacity-50 dark:border-neutral-700 dark:text-neutral-300 dark:hover:bg-neutral-800"
      >
        {t('channelContent.card.edit')}
      </button>
      <button
        type="button"
        id={`${EID['text-bulk-ready-row-discard-btn']}-${idSuffix}`}
        disabled={busy}
        onClick={onDiscard}
        className="rounded-md px-2.5 py-1.5 text-xs text-neutral-500 hover:text-neutral-700 disabled:opacity-50 dark:text-neutral-400 dark:hover:text-neutral-200"
      >
        {t('channelContent.card.discard')}
      </button>
      <span className="flex-1" />
      <button
        type="button"
        id={`${EID['text-bulk-ready-row-apply-btn']}-${idSuffix}`}
        disabled={busy}
        onClick={onApply}
        className="rounded-md bg-orange-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-orange-700 disabled:opacity-50"
      >
        {t('channelContent.card.apply')}
      </button>
    </div>
  )
}
